// extracted by mini-css-extract-plugin
export var brand = "_2q-9";
export var button = "_2q-0";
export var chevron = "_2q-v";
export var chevronButton = "_2q-w";
export var content = "_2q-n";
export var danger = "_2q-g";
export var dangerOutlined = "_2q-h";
export var dark = "_2q-l";
export var darkTheme = "_2q-c";
export var extraSmall = "_2q-4";
export var fullWidth = "_2q-8";
export var ghost = "_2q-d";
export var gray = "_2q-t";
export var icon = "_2q-p";
export var iconButton = "_2q-s";
export var iconButtonBorder = "_2q-x";
export var iconButtonBorderDark = "_2q-y";
export var iconButtonBorderLight = "_2q-z";
export var iconLeft = "_2q-q";
export var iconRight = "_2q-r";
export var large = "_2q-1";
export var light = "_2q-m";
export var medium = "_2q-2";
export var micro = "_2q-5";
export var nano = "_2q-7";
export var outlined = "_2q-k";
export var pending = "_2q-a";
export var primary = "_2q-i";
export var shadow = "_2q-o";
export var small = "_2q-3";
export var solidLight = "_2q-e";
export var solidLightBrand = "_2q-f";
export var spinner = "_2q-u";
export var transparent = "_2q-j";
export var warning = "_2q-b";
export var wideNano = "_2q-6";